function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgSecurityScreenIcon = function SvgSecurityScreenIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 40,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M18 37H5a4 4 0 0 1-4-4V21a4 4 0 0 1 4-4h20a4 4 0 0 1 3.48 2.024M7 17V9a8 8 0 1 1 16 0v8"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.accentFillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m29 27-4 6h8l-4 6M13 27a2 2 0 1 0 4 0 2 2 0 0 0-4 0"
  }));
};
export default SvgSecurityScreenIcon;